import React, { useState } from 'react';
import PracticeMode from '../../components/candidate/mock_interview_components/PracticeMode';
import MCQMode from '../../components/candidate/mock_interview_components/MCQMode';

function MockInterviewSetup() {
  const [activeTab, setActiveTab] = useState('practice');
  const [sessionActive, setSessionActive] = useState(false);

  const handleTabChange = (tab) => {
    if (!sessionActive) {
      setActiveTab(tab);
    }
  };

  const handleSessionStart = () => {
    setSessionActive(true);
  };

  const handleSessionEnd = () => {
    setSessionActive(false);
  };

  return (
    <div className="min-h-screen">
      {!sessionActive && (
        <div className="bg-white mb-5 rounded-lg shadow-md">
          <div className="max-w-7xl mx-auto">
            <ul className="nav nav-pills nav-fill">
              <li className="nav-item">
                <button
                  className={`nav-link  py-2 text-lg font-medium transition-colors duration-200 ${
                    activeTab === 'practice' 
                      ? 'active bg-blue-600 text-white' 
                      : 'text-gray-600 hover:bg-blue-50'
                  }`}
                  onClick={() => handleTabChange('practice')}
                >
                  Interview Mode
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link px-6 py-2 text-lg font-medium transition-colors duration-200 ${
                    activeTab === 'mcq' 
                      ? 'active bg-purple-600 text-white' 
                      : 'text-gray-600 hover:bg-purple-50'
                  }`}
                  onClick={() => handleTabChange('mcq')}
                >
                MCQ Mode
                </button>
              </li>
            </ul>
          </div>
        </div>
      )}

      <div className={sessionActive ? '' : 'pt-0'}>
        {activeTab === 'practice' && (
          <PracticeMode 
            onSessionStart={handleSessionStart}
            onSessionEnd={handleSessionEnd}
          />
        )}

        {activeTab === 'mcq' && (
          <MCQMode 
            onSessionStart={handleSessionStart}
            onSessionEnd={handleSessionEnd}
          />
        )}
        <div className="max-w-3xl mx-auto mt-8 px-4 py-3 border-l-4 border-yellow-400 bg-yellow-50 text-gray-700 text-sm italic rounded">
        Note: This is not a real simulation of an actual interview. It is intended for practice purposes only.
        </div>
      </div>
    </div>
  );
}

export default MockInterviewSetup;